import { useEffect, useState } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { FaExclamationTriangle } from 'react-icons/fa';
import { IMaskInput } from 'react-imask';
import Select from 'react-select';
import {
  IconOptionContactNauta,
  IconSingleValueContactNauta,
  reactSelectStyles,
} from '../../../../config/reactSelect';
import { useTopUp } from '../../../../context/TopupContext';
import { UtilService } from '../../../../services';
import { MegaContact } from '../../../../types/contacts';
import { TopUpNautaItem } from '../../../../types/topupItems';
import { MegaCarrier, MegaCarrierRate } from '../../../../types/topups';
import { TopupProducts, TopupProductsProps } from '../../topupProducts';
import { TopUpAddButton } from '../topupAddButton';
import { AlertHelper } from '../../../../utilities/AlertHelper';

export const TopUpNautaContacts = ({
  carrier,
  carrierRates,
  contacts,
  selContact,
}: {
  carrier: MegaCarrier;
  carrierRates: MegaCarrierRate[];
  contacts: MegaContact[];
  selContact: MegaContact | null;
}) => {
  const [selectedContact, setSelectedContact] = useState<MegaContact>();
  const [selectedContactCarrierRate, setSelectedContactCarrierRate] = useState<MegaCarrierRate>();
  const [productList, setProductList] = useState<TopupProductsProps['products']>([]);
  const [confirmationPhone, setConfirmationPhone] = useState<string>('');
  const [showConfirmationField, setShowConfirmationField] = useState<boolean>(false);
  const [warningMessage, setWarningMessage] = useState<string>('');
  const CUBA_MOBILE_MASK = '+{53} 0 000 0000';

  const { addNautaItem } = useTopUp();

  useEffect(() => {
    if (contacts.length > 0) {
      setSelectedContact(selContact || contacts[0]);
    }
  }, [contacts]);

  useEffect(() => {
    if (carrierRates.length > 0) {
      setSelectedContactCarrierRate(carrierRates[0]);
      convertProductList(carrierRates);
    }
  }, [carrierRates]);

  const convertProductList = (list: MegaCarrierRate[]) => {
    const newProductList: TopupProductsProps['products'] = UtilService.convertProductList(list);
    setProductList(newProductList);
  };

  const onSelectedProduct = (id: string) => {};

  const onAddTopup = (id: string, futureDate: string) => {
    const rate = carrierRates.find(
      (r) => `${r.id}` === `${id}` && `${r.future_date}` === `${futureDate}`
    );
    setSelectedContactCarrierRate(rate);
    if (rate) {
      if (rate.require_confirmation === 1) {
        setShowConfirmationField(true);
        if (!confirmationPhone || confirmationPhone.length < 8) {
          setWarningMessage('Por favor ingrese el número de confirmación.');
          return;
        }
      } else {
        setShowConfirmationField(false);
        setConfirmationPhone('');
      }
      try {
        addNautaItem({
          carrierRate: rate,
          contact: selectedContact,
          confirmation_phone: rate.require_confirmation === 1 ? confirmationPhone : undefined,
          type: 'contact',
        } as TopUpNautaItem);
        setConfirmationPhone('');
        setShowConfirmationField(false);
        setWarningMessage('');
      } catch (e: any) {
        AlertHelper.show({ icon: 'error', title: 'Error', text: e.toString() });
      }
    }
  };

  return (
    <>
      <Row>
        <Col lg={12}>
          <p className="mt-5 mb-2">Contacto</p>
          <Select
            value={selectedContact}
            options={contacts}
            isSearchable={false}
            isClearable={false}
            isLoading={false}
            className="w-100 mega-select"
            isMulti={false}
            styles={reactSelectStyles}
            components={{
              Option: IconOptionContactNauta,
              SingleValue: IconSingleValueContactNauta,
            }}
            onChange={(newValue) => {
              setSelectedContact(newValue as MegaContact);
            }}
          />
        </Col>
      </Row>

      {showConfirmationField && (
        <Row className="mt-4">
          <Col lg={12}>
            <div className="megaInput">
              <label htmlFor="confirmation_phone">Número de confirmación</label>
              <IMaskInput
                id="confirmation_phone"
                className="form-control mega"
                mask={CUBA_MOBILE_MASK}
                value={confirmationPhone}
                lazy={false}
                onAccept={(_value, mask) => setConfirmationPhone(mask.unmaskedValue || '')}
                onKeyDown={() => setWarningMessage('')}
              />
              <small className="text-secondary">
                Debe ser un número de celular cubano. Este número es obligatorio para que la recarga
                sea válida; un número inválido anulará esta recarga.
              </small>
            </div>
          </Col>
        </Row>
      )}

      {warningMessage && (
        <Alert variant={'warning'} className="mt-2">
          <FaExclamationTriangle /> {warningMessage}
        </Alert>
      )}

      <Row className="mt-3">
        <Col>
          <hr />
        </Col>
      </Row>

      <Row>
        <Col>
          {!!productList && productList.length > 0 && !!selectedContactCarrierRate && (
            <TopupProducts
              serviceType="nauta"
              selectedId={selectedContactCarrierRate.id}
              products={productList}
              onSelectedChange={onSelectedProduct}
              onAddTopup={onAddTopup}
            />
          )}
        </Col>
      </Row>
    </>
  );
};
